import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";

export default function Stats() {
    const { t } = useI18n();
    const stats = [
        { key: "leads", ...t.landing.stats.leads },
        { key: "emails", ...t.landing.stats.emails },
        { key: "time", ...t.landing.stats.time },
        { key: "credits", ...t.landing.stats.credits },
    ];
    return (
        <section className="relative py-16">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {stats.map((s, i) => (
                        <motion.div
                            key={s.key}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            viewport={{ once: true }}
                            data-testid={TEST_IDS.landing.stat(s.key)}
                            className="glass rounded-2xl p-6"
                        >
                            <div className="font-display text-3xl sm:text-4xl font-black tracking-tight text-white">{s.value}</div>
                            <div className="mt-2 text-sm text-zinc-400">{s.label}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
